import {
    SU_ADD_PROPERTY,
    SU_DELETE_PROPERTY,
    CHANNEL_MAPPING,
    LOAD_MAPPING_DATA,
} from './types';

import { BACKEND_API } from "../../config/middleware";
import API from "../../config/api-url";


export const loadMappingData = () => ({
    type: BACKEND_API,
        payload: Object.assign(
        {
            type: LOAD_MAPPING_DATA,
            method: 'get',
            url: API.CHANNEL_MAPPING
        },
    )
});

export const channelMapping = data => ({
    type: BACKEND_API,
        payload: Object.assign(
        {
            type: CHANNEL_MAPPING,
            method: 'post',
            url: API.CHANNEL_MAPPING,
            data: data,
        },
    )
});

export const addProperty = data => ({
    type: BACKEND_API,
        payload: Object.assign(
        {
            type: SU_ADD_PROPERTY,
            method: 'post',
            url: API.CONNECT_PROPERTY_TO_SU,
            data: data,
        },
    )
});

export const deleteProperty = data => ({
    type: BACKEND_API,
    payload: Object.assign(
        {
            type: SU_DELETE_PROPERTY,
            method: 'delete',
            url: API.CONNECT_PROPERTY_TO_SU,
            data: data,
        },
    )
});